import {Template} from "../../../../components/template/template.jsx";
import Button from "../../../../components/button/button.jsx";
import {FaCopy, FaExternalLinkAlt, FaPen} from "react-icons/fa";
import {FaPrint} from "react-icons/fa6";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import {Card} from "../../../../components/card/card.jsx";
import {useQuery} from "@tanstack/react-query";
import EncounterService from "../../../../services/web/encounter-service.js";
import {useParams} from "react-router";
import {EncounterContent} from "../components/encounter-content.jsx";
import ProjectUtils from "../../../../utils/project-utils.js";
import {toast} from "react-toastify";
import React, {useRef, useState} from "react";
import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";
import HeaderTemplateButton from "../../../../components/button/header-template-button.jsx";
import {navigateHook} from "../../../../hooks/use-navigate.js";

export default function EncounterForm(){
    const navigate = navigateHook();
    const { id } = useParams();
    const printRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [showImagePrint, setShowImagePrint] = useState(false);
    const [headerSelected, setHeaderSelected] = useState(-1);

    const { data, isLoading: isLoading } = useQuery({
        queryKey: ['encounter-edit', id],
        queryFn: () => EncounterService.getEncounter(id).then(r => r.data),
        enabled: !!id,
        retry: false,
    });

    const canEdit = !!data?.can_edit;
    const encounter = data?.encounter;

    const handleCopy = () => {
        ProjectUtils.copyToClipboard(id);
        toast.success("ID da Abordagem copiado.");
    };

    return (
        <Template isLoading={isLoading || loading}>
            <Template.Header>
                <Template.Title>
                    <div className="flex items-center">
                        <button type="button" className="cursor-pointer flex flex-row gap-2 hover:text-[#262829]!" title="Copiar ID da abordagem" onClick={handleCopy}>
                            <FaCopy className="text-base transform translate-y-1.25"/> Abordagem - {id}
                        </button>

                        { data?.encounter?.dispatchId &&
                            <span className={"pl-4 cursor-pointer hover:text-[#262829]!"} title={'Acessar despacho'} onClick={() => navigate("/despacho/dispatch/form/" + data?.encounter?.dispatchId, true)}>
                                <FaExternalLinkAlt size={16}/>
                            </span>
                        }
                    </div>
                </Template.Title>

                { data && !isLoading && (
                    <div className="flex gap-2">
                        <div className="flex gap-2 text-sm items-center pr-2">
                            <InputCheckbox
                                id={'printImages'}
                                label={'Exibir imagens na impressão'}
                                checked={showImagePrint}
                                onChange={(e) => setShowImagePrint(e?.target?.checked)}
                                invert={true}
                            />
                        </div>

                        <Button title="Imprimir" onClick={() => printRef.current?.print()}><FaPrint/></Button>

                        <HeaderTemplateButton selected={headerSelected} setSelected={setHeaderSelected} menuClassName={`${canEdit ? 'right-26!' : ''}`}/>

                        { canEdit && (
                            <Button onClick={() => navigate(`/encounter/form/${id}/edit`, false)}><FaPen/> Editar</Button>
                        )}
                    </div>
                )}

            </Template.Header>
            <Template.Body className={'pl-0!'}>
                { data ? (
                    <Card className={'w-full max-w-[1030px] mx-auto p-[0]!'}>
                        <Card.Body>
                            <PrintTemplate ref={printRef} entity={headerSelected} title={`Abordagem - ${id}`}
                                           printFooterClassname="hidden print:block" setIsPrinting={setLoading}>

                                <EncounterContent data={encounter} showImages={showImagePrint}/>

                            </PrintTemplate>
                        </Card.Body>
                    </Card>
                ) : (
                    <>
                        { !isLoading && (
                            <div id="noDataMessage" className={"justify-center alert alert-info p-2 h6 text-center mx-auto mt-5! max-w-[1030px]"}>
                                Nenhum registro encontrado.
                            </div>
                        )}
                    </>
                )}
            </Template.Body>
        </Template>
    )
}